module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/gb-35dbacd736781608964ae37a3b390b48.svg";